import { URLConfig } from './../../configurations/url-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestFloatTransferService {
  apiService = inject(ApiService)

  constructor(private http:HttpClient) { }

  getTellerList(agentAccount:string, amount:string){
    const params = {agentAccount, amount}
    let agentTellerId = localStorage.getItem('tellerKey')
    let headers = new HttpHeaders();
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.get(URLConfig.agentFloatTellerList, {params, headers})
  }

  requestFloat(request: any): Observable<any> {
    let agentTellerId = localStorage.getItem('tellerKey')
    // let agentTellerId = '23508220';
    let headers = new HttpHeaders();
    if (agentTellerId) {
        headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.post<any>(URLConfig.agentFloatTellerRequest, request,{headers});
  }

  getApprovalPendingRequest(){
    const user = JSON.parse(localStorage.getItem('user') as string);
    const params = {approverTellerAccess: user.tellerKey}

    let headers = new HttpHeaders();
    let agentTellerId = localStorage.getItem('tellerKey')
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.get(URLConfig.approvalPendingRequest, {params, headers});
  }
  
  getApprovedRequests(){
    const user = JSON.parse(localStorage.getItem('user') as string);
    const params = {applicantTellerAccess: user.tellerKey}

    let headers = new HttpHeaders();
    let agentTellerId = localStorage.getItem('tellerKey')
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.get(URLConfig.confirmingApprovedRequest, {params, headers});
  }

  validatePayment(body:any){
    let headers = new HttpHeaders();
    let agentTellerId = localStorage.getItem('tellerKey')
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.post(URLConfig.validatePendingRequest, body, {headers})
  }

  confirmPayment(body:any){
    let headers = new HttpHeaders();
    let agentTellerId = localStorage.getItem('tellerKey')
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.post(URLConfig.confirmRequest, body, {headers})
  }
}
